// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#304156","menuText":"#fff","menuActiveText":"#1890ff"};